module.exports = __webpack_public_path__ + "static/media/logo-icon-notification.78da2193.png";